import React from "react";

import { changePath } from "@Core/Helpers/utility";

const NoRoute = ({ history }) => {
  return (
    <div>
         <div className="d-flex align-items-center justify-content-center vh-100">
            <div className="text-center flex-1">
                <h1 className="display-1 fw-bold">404</h1>
                <p className="fs-3 mb-3"> <span className="text-danger">Opps!</span> Page not found.</p>
                <p className="lead mb-3">
                    The page you’re looking for doesn’t exist.
                  </p>
                <button onClick={e=>history.push(process.env.REACT_APP_HOME_ROUTE)} className="cta cta--contained cta--black mb-2">Go Home</button>
            </div>
        </div>
    </div>
  );
};

export default NoRoute;
